import { Suspense, lazy } from "react";
import { cn } from "@/lib/utils";
import type { MarkdownProps } from "@/components/Markdown/props";

const Impl = lazy(() =>
  import("@/components/Markdown/MarkdownImpl").then((m) => ({ default: m.Markdown })),
);

export type { MarkdownProps };

export function Markdown({ source, className, imageUrls, onImageClick }: MarkdownProps) {
  return (
    <Suspense
      fallback={<div className={cn("rich-text whitespace-pre-wrap", className)}>{source}</div>}
    >
      <Impl
        source={source}
        className={className}
        imageUrls={imageUrls}
        onImageClick={onImageClick}
      />
    </Suspense>
  );
}
